import { render, staticRenderFns } from "./study-label-select.vue?vue&type=template&id=94eb127e&scoped=true&"
import script from "./study-label-select.vue?vue&type=script&lang=ts&"
export * from "./study-label-select.vue?vue&type=script&lang=ts&"
import style0 from "./study-label-select.vue?vue&type=style&index=0&id=94eb127e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94eb127e",
  null
  
)

export default component.exports